import React from 'react';
import { Link } from 'react-router-dom';
import {
LightBulbIcon, ArrowRightIcon, CpuChipIcon, FireIcon, QuestionMarkCircleIcon,
SparklesIcon, PuzzlePieceIcon, HandRaisedIcon, WrenchScrewdriverIcon,
AcademicCapIcon, CheckCircleIcon, ExclamationCircleIcon, ArrowLeftIcon
} from '@heroicons/react/24/solid';
const Bashar15MinutesAndCounting2 = ({ nextActivity, onProceed }) => {

const ExpansionDiagram = () => (
    <div className="flex flex-col items-center justify-center p-4">
        <h3 className="text-2xl font-bold text-gray-100 mb-12 uppercase">Expansion</h3>
        <div className="relative flex items-center justify-center w-80 h-80 rounded-full border-2 border-green-500"> {/* Outer Circle */}
            <p className="absolute -top-6 text-green-300 font-semibold">GROWTH</p>
            <p className="absolute -bottom-6 text-green-300 font-semibold">INSPIRATION</p>

            <div className="absolute w-56 h-56 rounded-full border-2 border-blue-400 flex items-center justify-center"> {/* Middle Circle */}
                <p className="absolute -top-8 text-blue-300 font-semibold">CHOICE</p>
                <p className="absolute -bottom-8 text-blue-300 font-semibold">FREEDOM</p>

                {/* Wavy line */}
                <svg className="absolute w-[80%] h-auto" style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} viewBox="0 0 100 10" preserveAspectRatio="none">
                    <path d="M0 5 Q 25 0, 50 5 T 100 5" stroke="white" strokeWidth="0.5" fill="none"/>
                    <circle cx="0" cy="5" r="0.8" fill="white" />
                    <circle cx="100" cy="5" r="0.8" fill="white" />
                </svg>

                <div className="absolute w-32 h-32 rounded-full border-2 border-yellow-300 flex items-center justify-center bg-yellow-950"> {/* Center Circle */}
                    <p className="text-yellow-100 font-bold text-center leading-tight">POS.<br/>BELIEF</p>
                </div>
            </div>
        </div>
        <p className="text-lg font-bold text-green-300 mt-12 text-center leading-tight">REINFORCEMENT OF<br/>POSITIVE<br/>SYNCHRONICITY</p>
    </div>
);

const ContractionDiagram = () => (
    <div className="flex flex-col items-center justify-center p-4">
        <h3 className="text-2xl font-bold text-gray-100 mb-6 uppercase">Contraction</h3>
        <div className="relative w-[360px] h-[450px] flex flex-col items-center justify-center text-center text-xs font-semibold">

            {/* Central elements */}
            {/* NO CHOICE */}
            <div className="absolute w-[100px] h-12 bg-red-700 border border-red-500 rounded-sm flex items-center justify-center text-red-100 leading-tight z-10"
                 style={{ top: '150px', left: 'calc(50% - 50px)' }}>NO CHOICE</div>

            {/* NEG. BELIEF / SURVIVAL */}
            <div className="absolute w-[120px] h-16 bg-red-900 border border-red-500 rounded-sm flex flex-col items-center justify-center text-red-100 leading-tight z-10"
                 style={{ top: '220px', left: 'calc(50% - 60px)' }}>NEG. BELIEF<br/>SURVIVAL</div>

            {/* Outer shapes */}
            {/* JUSTIFY */}
            <div className="absolute w-[100px] h-12 bg-gray-800 border border-red-500 rounded-sm flex items-center justify-center text-red-200 z-0"
                 style={{ top: '60px', left: 'calc(50% - 100px)' }}>JUSTIFY</div>
            {/* RATIONALIZE */}
            <div className="absolute w-[100px] h-12 bg-gray-800 border border-red-500 rounded-sm flex items-center justify-center text-red-200 z-0"
                 style={{ top: '60px', left: 'calc(50% + 0px)' }}>RATIONALIZE</div>

            {/* REJECT */}
            <div className="absolute w-[100px] h-12 bg-gray-800 border border-red-500 rounded-sm flex items-center justify-center text-red-200 z-0"
                 style={{ top: '220px', left: '0px' }}>REJECT</div>
            {/* REWARD */}
            <div className="absolute w-[100px] h-12 bg-gray-800 border border-red-500 rounded-sm flex items-center justify-center text-red-200 z-0"
                 style={{ top: '220px', right: '0px' }}>REWARD</div>

            {/* PROJECT */}
            <div className="absolute w-[100px] h-12 bg-gray-800 border border-red-500 rounded-sm flex items-center justify-center text-red-200 z-0"
                 style={{ top: '330px', left: 'calc(50% - 100px)' }}>PROJECT</div>
            {/* PARANOIA */}
            <div className="absolute w-[100px] h-12 bg-gray-800 border border-red-500 rounded-sm flex items-center justify-center text-red-200 z-0"
                 style={{ top: '330px', left: 'calc(50% + 0px)' }}>PARANOIA</div>

            {/* Arrows */}
            {/* NO CHOICE <-> NEG. BELIEF / SURVIVAL */}
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 rotate-90" style={{ top: '200px', left: 'calc(50% - 8px)' }}/>
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 -rotate-90" style={{ top: '190px', left: 'calc(50% - 8px)' }}/>

            {/* JUSTIFY -> NO CHOICE */}
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 -rotate-45" style={{ top: '135px', left: 'calc(50% - 70px)' }}/>
            {/* RATIONALIZE -> NO CHOICE */}
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 rotate-45" style={{ top: '135px', left: 'calc(50% + 55px)' }}/>

            {/* REJECT -> NEG. BELIEF / SURVIVAL */}
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 rotate-15" style={{ top: '240px', left: 'calc(50% - 110px)' }}/>
            {/* REWARD -> NEG. BELIEF / SURVIVAL */}
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 -rotate-15" style={{ top: '240px', left: 'calc(50% + 100px)' }}/>

            {/* PROJECT -> NEG. BELIEF / SURVIVAL */}
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 rotate-45" style={{ top: '365px', left: 'calc(50% - 70px)' }}/>
            {/* PARANOIA -> NEG. BELIEF / SURVIVAL */}
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 -rotate-45" style={{ top: '365px', left: 'calc(50% + 55px)' }}/>

            {/* JUSTIFY <-> RATIONALIZE */}
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400" style={{ top: '75px', left: 'calc(50% - 5px)' }}/>
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 rotate-180" style={{ top: '75px', left: 'calc(50% - 25px)' }}/>

            {/* PROJECT <-> PARANOIA */}
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400" style={{ top: '395px', left: 'calc(50% - 5px)' }}/>
            <ArrowRightIcon className="absolute w-4 h-4 text-gray-400 rotate-180" style={{ top: '395px', left: 'calc(50% - 25px)' }}/>

        </div>
        <p className="text-lg font-bold text-red-300 mt-6 text-center leading-tight">REINFORCEMENT OF<br/>NEGATIVE<br/>SYNCHRONICITY</p>
    </div>
);


return (
    <div className="w-full bg-gray-900 animate-fade-in">
        <div className="max-w-3xl mx-auto py-6 px-4 sm:px-6 lg:px-8">

            <div className="bg-gray-900 p-6 rounded-xl border border-blue-500/20 mb-8">
                <h1 className="text-3xl font-bold text-blue-400 mb-4 text-center">Bashar: Brick Walls and Beliefs (Second Transmission)</h1>
                <p className="text-gray-300 text-center">
                    This transmission focuses on the <span className="font-bold text-yellow-300">power of manifestation</span> and the <span className="font-bold text-yellow-300">plasticity of the brain's neural network</span>, explaining how our beliefs define our reality and how we can reconfigure them.
                </p>
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-yellow-500/20 mb-8">
                <h2 className="text-2xl font-bold text-yellow-400 mb-4 text-center">Your Brain: A Constantly Rewiring Neurological Network</h2>
                <div className="flex flex-col items-center gap-4 text-center">
                    <CpuChipIcon className="w-10 h-10 text-yellow-300 mb-2"/>
                    <p className="text-gray-400">
                        Every thought, idea, feeling, and belief you have <span className="font-bold text-green-300">literally changes the neural pathways in your brain</span>.
                    </p>
                    <ArrowRightIcon className="w-8 h-8 text-white/30 my-1 rotate-90 sm:rotate-0" />
                    <p className="text-gray-400">
                        It takes approximately <span className="font-bold text-orange-300">15 minutes</span> for the brain to go from a plastic state to a crystallized one, locking in this new information. This period is crucial for the brain to become a "more refined receiver" of "downloads" from the higher mind.
                    </p>
                </div>
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-purple-500/20 mb-8">
                <h2 className="text-2xl font-bold text-purple-400 mb-4 text-center">Pleasure vs. Pain: The Engine of Your Choices</h2>
                <div className="flex flex-col items-center gap-4 text-center">
                    <FireIcon className="w-10 h-10 text-purple-300 mb-2"/>
                    <p className="text-gray-400">
                        Human beings always move toward what they perceive as <span className="font-bold text-pink-300">more pleasurable</span> and away from what they perceive as <span className="font-bold text-red-300">more painful</span>.
                    </p>
                    <ArrowRightIcon className="w-8 h-8 text-white/30 my-1 rotate-90 sm:rotate-0" />
                    <p className="text-gray-400">
                        If you don't choose what you would prefer, it's because an associated <span className="font-bold text-red-300">negative belief</span> makes that preference seem painful or unappealing, or the fear of the unknown makes you prefer the familiar pain.
                    </p>
                </div>
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-teal-500/20 mb-8">
                <h2 className="text-2xl font-bold text-teal-400 mb-4 text-center">Manifestation: Making the Invisible Visible</h2>
                <div className="flex flex-col items-center gap-4 text-center">
                    <SparklesIcon className="w-10 h-10 text-teal-300 mb-2"/>
                    <p className="text-gray-400">
                        Manifestation is not about attracting something that doesn't exist, but about <span className="font-bold text-cyan-300">making the invisible visible</span>. What we desire already exists in our reality; our beliefs simply render it invisible.
                    </p>
                    <p className="text-gray-400">
                        It is a process of <span className="font-bold text-cyan-300">altering perception</span>.
                    </p>
                </div>
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-orange-500/20 mb-8">
                <h2 className="text-2xl font-bold text-orange-400 mb-4 text-center">The Paradoxical Mechanism of Manifestation</h2>
                <p className="text-gray-300 mb-4 text-center">
                    The manifestation mechanism uses the <span className="font-bold text-yellow-300">power of paradox</span>, where two seemingly contradictory ideas coexist, indicating your point of creative power.
                </p>
                <div className="grid md:grid-cols-2 gap-6">
                    <div className="bg-gray-800 p-4 rounded-lg border border-orange-400/50">
                        <h3 className="text-xl font-bold text-orange-300 mb-2 flex items-center gap-2"><LightBulbIcon className="w-6 h-6"/> 1. Intention, Focus, and Concentration</h3>
                        <p className="text-gray-400">
                            Visualize your passionate idea, feel it, and build that energy to a peak for <span className="font-bold text-yellow-300">no more than 15 minutes</span>, preferably in a meditative state. This initiates the process of making the invisible visible.
                        </p>
                    </div>
                    <div className="bg-gray-800 p-4 rounded-lg border border-orange-400/50">
                        <h3 className="text-xl font-bold text-orange-300 mb-2 flex items-center gap-2"><HandRaisedIcon className="w-6 h-6"/> 2. Complete Letting Go and Surrender</h3>
                        <p className="text-gray-400">
                            After the 15 minutes, <span className="font-bold text-yellow-300">let it go completely</span>, forget about it, and surrender it to your higher mind. The physical mind is not designed to understand the "how"; trying to control it blocks the process.
                        </p>
                    </div>
                </div>
                <p className="mt-4 text-gray-400 text-center">
                    It is crucial that your motivation is a true passion, not an avoidance of negative beliefs.
                </p>
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-green-500/20 mb-8">
                <h2 className="text-2xl font-bold text-green-400 mb-4 text-center">Synergy: Physical Mind and Higher Mind</h2>
                <div className="flex flex-col items-center gap-4 text-center">
                    <PuzzlePieceIcon className="w-10 h-10 text-green-300 mb-2"/>
                    <p className="text-gray-400">
                        To function as a "whole being," your <span className="font-bold text-lime-300">physical mind and higher mind must work together</span>.
                    </p>
                    <ArrowRightIcon className="w-8 h-8 text-white/30 my-1 rotate-90 sm:rotate-0" />
                    <p className="text-gray-400">
                        By concentrating intensely on a passion, you raise your frequency and <span className="font-bold text-lime-300">expand your "energy bubble"</span> of all possible probabilities. By letting go and surrendering, this bubble "collapses" back to immediate reality, selecting the <span className="font-bold text-lime-300">highest probabilities</span> and paths of least resistance for manifestation.
                    </p>
                </div>
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-red-500/20 mb-8">
                <h2 className="text-2xl font-bold text-red-400 mb-4 text-center">The Self-Perpetuating Nature of Beliefs</h2>
                <QuestionMarkCircleIcon className="w-10 h-10 text-red-300 mx-auto mb-2"/>
                <p className="text-gray-400 text-center">
                    The key to making the manifestation mechanism work is <span className="font-bold text-orange-300">addressing beliefs</span>. All beliefs, whether positive or negative, are <span className="font-bold text-orange-300">self-reinforcing</span> and self-perpetuating. This is a constant choice we make in every moment, creating the illusion of continuity.
                </p>
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-blue-500/20 mb-8 flex justify-center">
                <ExpansionDiagram />
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-red-500/20 mb-8 flex justify-center">
                <ContractionDiagram />
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-yellow-500/20 mb-8">
                <h2 className="text-2xl font-bold text-yellow-400 mb-4 text-center">Deciphering the "Tricks" of Negative Beliefs</h2>
                <ul className="list-disc list-inside space-y-3 text-gray-300">
                    <li><span className="font-bold text-white">Fear of death:</span> They connect to the survival instinct, making changing the belief seem like an existential threat ("suicide").</li>
                    <li><span className="font-bold text-white">"No choice":</span> They create the illusion that change is impossible and hide the "door to the light" that always exists.</li>
                    <li><span className="font-bold text-white">Diversion tactics:</span> They use projection, rejection of ideas, and paranoia to divert you from the truth.</li>
                    <li><span className="font-bold text-white">Reward:</span> They offer positive reinforcement for you to keep choosing the negative path, making you feel "safe" or "rewarded" for it.</li>
                    <li><span className="font-bold text-white">Fear of testing the positive:</span> They dissuade you from seeking proof of the positive, suggesting you will only find more evidence of the negative, keeping you in a "safe" but miserable state of doubt.</li>
                </ul>
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-green-500/20 mb-8">
                <h2 className="text-2xl font-bold text-green-400 mb-4 text-center">Strategies for Overcoming Negative Beliefs</h2>
                <ul className="list-disc list-inside space-y-3 text-gray-300">
                    <li><span className="font-bold text-white">Knowledge is power:</span> Recognizing and understanding their structure and "tricks" removes their logic and makes them transparent, revealing them as illusions. <AcademicCapIcon className="inline-block w-5 h-5 text-green-300"/></li>
                    <li><span className="font-bold text-white">The "crack":</span> By "burning" this understanding into your neural network, a crack is created in the negative belief's blueprint, showing you the way out. <WrenchScrewdriverIcon className="inline-block w-5 h-5 text-green-300"/></li>
                    <li><span className="font-bold text-white">Unmasking their arguments:</span> Once the template is integrated, you will be able to recognize their tricks and will no longer be completely fooled. <ExclamationCircleIcon className="inline-block w-5 h-5 text-green-300"/></li>
                    <li><span className="font-bold text-white">Validate, don't annihilate:</span> Instead of trying to destroy the negative belief, you recognize it as a <span className="font-bold text-green-300">valid option</span> within your reality, but you choose your preference. This strips it of its power and leaves it "quiescent". <CheckCircleIcon className="inline-block w-5 h-5 text-green-300"/></li>
                    <li><span className="font-bold text-white">Use doubt to your advantage:</span> The small doubt that negative beliefs must leave can be used to turn it against them and move you toward the light. <QuestionMarkCircleIcon className="inline-block w-5 h-5 text-green-300"/></li>
                </ul>
            </div>

            <div className="mt-12 text-center">
                <div className="bg-gray-900 p-6 rounded-xl border border-teal-500/20 mb-8 max-w-2xl mx-auto">
                     <LightBulbIcon className="w-10 h-10 text-teal-400 mx-auto mb-3" />
                    <h2 className="text-xl font-bold text-teal-300 mb-2">Integrating Knowledge for Liberation</h2>
                    <p className="text-gray-300">
                        The process of integrating this knowledge into your neural network creates a <span className="font-bold text-teal-300">lasting "virtual memory"</span>, which acts as an "echo" that there are always other options. Having the physical diagrams in sight helps reinforce this integration in your brain.
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-6">
                    <Link to="/bashar/tools/15-min-count/1" className="inline-flex items-center gap-2 bg-gray-700 text-gray-300 font-bold py-3 px-6 rounded-lg hover:bg-gray-600 transition-colors">
                        <ArrowLeftIcon className="w-5 h-5"/>
                        Go to Part 1
                    </Link>
                    {nextActivity && (
                        <button
                            onClick={onProceed}
                            className="inline-flex items-center gap-2 bg-yellow-500 text-black font-bold py-3 px-8 rounded-lg hover:bg-yellow-400 transition-colors"
                        >
                            Continue to the Next Activity
                            <ArrowRightIcon className="w-5 h-5"/>
                        </button>
                    )}
                    <Link to="/bashar/tools/15-min-count/3" className="inline-flex items-center gap-2 bg-gray-700 text-gray-300 font-bold py-3 px-6 rounded-lg hover:bg-gray-600 transition-colors">
                        Go to Part 3
                        <ArrowRightIcon className="w-5 h-5"/>
                    </Link>
                </div>

                <div className="text-center mt-6">
                    <Link to="/courses/manifest" className="text-sm text-gray-500 hover:text-yellow-400 transition-colors">Back to Syllabus</Link>
                </div>
            </div>
        </div>
    </div>
);
};
export default Bashar15MinutesAndCounting2;